import React from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';

import resultLabel from './resultLabel';

const Container = styled(View)`
  flex-direction: row;
  column-gap: 10px;
  margin: 5px;
`;

const Detail = styled(View)`
  width: fit-content;
`;

const Result = ({ result, onSelect }) => {
  return (
    <Pressable
      onPress={() => onSelect(result)}
      style={state => (
        {
          backgroundColor: state.hovered ? 'lightgray' : 'none'
        }
      )}
    >
      <Container>
        <Detail>
          <Text>{resultLabel(result)}</Text>
        </Detail>
      </Container>
    </Pressable>
  );
};

export default Result;
